







import { Component } from 'vue-property-decorator';
import Buttons from '../../ScoreInput/Buttons.vue';
import ClassEES from './ClassEES';

@Component({ components: { Buttons } })
export default class ClassEESButton extends ClassEES {}
